import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators as dbCreators } from '../afw/store/db';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ContentParser from '../components/ContentParser/ContentParser';
import ContentArea from '../afw/components/ContentArea/ContentArea';
import Banner from '../components/Banner/Banner';
import {Helmet} from 'react-helmet';
import BreadCrumbs from '../components/BreadCrumb/BreadCrumb';
import moment from 'moment'
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  loader: {
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    zIndex: 4
  },
  wrapper: {
    margin: '0px 100px',
    [theme.breakpoints.down('md')]: {
      margin: '0 25px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0px',
    },
  },
  hideOnMedAndDown:{
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  alignMiddle: {
    display: 'inline-block',
    verticalAlign: 'middle'
  }
});

class Secondary extends Component {
  constructor(props){
    super(props);
    const {page_name} = props.match.params;
    this.state={
      page_name,
      data: {
        t_page: {
          page_prop: {
            style: {
              style: {},
              margins: ""
            }
          }
        }
      },
      notFound: false,
      underConstruction: false,
      HomePageData: props.HomePageData
    }
    
  }
  async componentDidMount(){
    const data = await this.handleLoadData();
    this.setState(this.handleCheckData(data));
  }
  async componentDidUpdate(_, prevState){
    if(prevState.page_name !== this.state.page_name){
      const data = await this.handleLoadData();
      this.setState(this.handleCheckData(data))
    }
  }
  handleCheckData=(data)=>{
    if(typeof data === 'string'){
      if(data === 'Under Construction') return {underConstruction: true, notFound: false, loading: false, publish_date: this.publish_date}
      return {notFound: true, underConstruction: false, loading: false, publish_date: undefined}
    }else{
      return {data, loading: false, notFound: false, underConstruction: false, publish_date: undefined}
    }
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.match.params.page_name !== prevState.page_name){
      return { page_name: nextProps.match.params.page_name, loading: true }
    }
    return null;
  }
  mapComponentsToData=async ({prop, value}, components)=>{
    let obj = {};
    const {db} = this.props;
    if(Array.isArray(value)){
      obj[prop] = value.map(component_name=>new db.Model.t_component(components.find((o=>o.component_name === component_name))));
      for(var i = 0; i < obj[prop].length; i++){
        const table = obj[prop][i].datasource.table;
        if(table){
          const data = await db[table].load(obj[prop][i].datasource.loadoptions);
          obj[table] = data.map(o=>new db.Model[table](o));
        }
      }
    }
    return obj;
  }
  handleLoadData=async()=>{
    const {page_name} = this.state;
    const {db} = this.props;
    let data = {t_page: new db.Model.t_page()}
    if(page_name){
      const pageInfo = await db.t_page_layout.load({
        expand: ['t_page', 't_component', 'SR_t_page_layout_LAYOUT_PARENT($levels=max;$expand=t_component($expand=t_cd_component))'],
        filter: [['t_page.url_link', '=', `portal/${page_name}`], ['layout_parent', '=', null]],
        select: [
          'layout_id','page_id','order','col','row','colspan','rowspan','colcount','rowcount', 
          't_page.page_id','t_page.page_name','t_page.page_title','t_page.page_desc','t_page.page_prop','t_page.active_ind','t_page.banner_ind','t_page.publish_date','t_page.page_tags'
        ]
      })
      if(!pageInfo[0]) return "Not Found";
      this.publish_date = pageInfo[0].t_page.publish_date
      if(moment(pageInfo[0].t_page.publish_date).isAfter(moment())) return "Under Construction"
      pageInfo[0].SR_t_page_layout_LAYOUT_PARENT = pageInfo[0].SR_t_page_layout_LAYOUT_PARENT.sort((a, b) => a.row - b.row).sort((a, b) => a.col - b.col);
      let t_page = {...pageInfo[0].t_page}
      pageInfo.map(o=>{
        delete o.t_page;
        return o;
      })
      t_page.t_page_layout = pageInfo;
      data.t_page = new db.Model.t_page(t_page);
    }
    return data;
  }
  handleRenderContent=(t_page_layout)=>{
    return t_page_layout.filter(o=>o.layout_parent === null).map((o,i)=>{
      return (
        <ContentArea key={o.page_name} colCount={o.col} rowCount={o.row}>
          {o.SR_t_page_layout_LAYOUT_PARENT.map((p,j)=>{
            return (
              <ContentParser key={p.layout_id} data={p} index={j} />
            )
          })}
        </ContentArea>
      )
    })
  }
  render() {
    const {data, underConstruction, notFound} = this.state;
    // const t_page_layout = data.t_page && data.t_page.t_page_layout || [];
    const t_page_layout = data.t_page && data.t_page.t_page_layout ? data.t_page.t_page_layout : [];
    let {page_prop} = data.t_page;
    page_prop.style = page_prop.style || {style: {}, margins: ""};
    const {classes} = this.props;
    return (
      <div className={classes.root}>
        {
          underConstruction && (
            <div>
              <Helmet>
                <title>{data.t_page.page_title}</title>
                <meta name="description" content={data.t_page.page_desc} />
              </Helmet>
              <div style={{textAlign: 'center', marginTop: '20px'}}>
                <i style={{fontSize: '50px', borderRadius: '50%', padding: '10px', marginRight: '10px'}} className={`material-icons mi-traffic yellow-text black ${classes.alignMiddle}`} />
                <Typography variant="h3" className={classes.alignMiddle}>Page under construction</Typography>
              </div>
              <div style={{textAlign: 'center'}}>
                <Typography variant="h6">
                  This page is undergoing changes, the current estimated completion date is {moment(this.state.publish_date).format("MMMM Do YYYY, h:mm:ss a")}.
                </Typography>
                <Typography variant="h6">
                  For any questions, use our <a href="http://mdot.ms.gov/applications/commentform/#home" target="_blank" rel="noreferrer">Contact Form</a>, please allow 3-5 business days for response.
                </Typography>
              </div>
            </div>
          )
        }
        {
          notFound && (
            <div>
              <Helmet>
                <title>{"Page Not Found"}</title>
                <meta name="description" content={"Page Not Found"} />
              </Helmet>
              <div style={{textAlign: 'center', marginTop: '20px'}}>
                <i style={{fontSize: '50px'}} className={`material-icons mi-warning red-text ${classes.alignMiddle}`} />
                <Typography variant="h3" className={classes.alignMiddle}>We're sorry, this page could not be found.</Typography>
              </div>
              <div style={{textAlign: 'center'}}>
                <Typography variant="h6" className={classes.alignMiddle}>
                  To report a missing or dead link on the site, use our <a href="http://mdot.ms.gov/applications/commentform/#home" target="_blank" rel="noreferrer">Contact Form</a>, please allow 3-5 business days for response.
                </Typography>
              </div>
            </div>
          )
        }
        {
          (!notFound && !underConstruction) && (
            <React.Fragment>
              <Helmet>
                <title>{data.t_page.page_title}</title>
                <meta name="description" content={data.t_page.page_desc} />
              </Helmet>
              <div className={classes.spacer}>
                <BreadCrumbs navData={data.t_page.page_tags || []} currentPage={data.t_page.page_title}/>
                {
                  page_prop.banner && data.t_page.banner_ind && (
                    <div>
                      <Banner title={data.t_page.page_title} {...data.t_page.page_prop.banner}/>
                    </div>
                  )
                }
                <div className={classes.wrapper} style={{...page_prop.style.style, margin: page_prop.style.margins || ""}}>
                  {this.handleRenderContent(t_page_layout)}
                </div>
              </div>
            </React.Fragment>
          )
        }
        </div>
    );
  }
}
Secondary.propTypes = {
  classes: PropTypes.object.isRequired
};

export default connect(
  state => ({db: state.db}),
  dispatch => bindActionCreators({...dbCreators}, dispatch)
)(withStyles(styles)(Secondary));